export const BidProfileWarningCodes = Object.freeze({
    PartialPublish: 'partialPublish',
    ActivationFailedPreferential: 'activationFailedPreferential',
    ActivationFailedSequential: 'activationFailedSequential',
    CalendarRuleConflict: 'calendarRuleConflict',
    ActivatedCalendarRuleConflict: 'activatedCalendarRuleConflict',
    DeletedTeamDefinition: 'deletedTeamDefinition',
});
